/**
 * Espelho local dos tipos do pacote `@greennexus/schemas`
 * (modulo `events/consolidate`). Origem canonica:
 *
 *   gn-schemas/packages/typescript/src/events/consolidate.ts
 *
 * Copia local porque `@greennexus/schemas` ainda nao esta declarado
 * como dependencia em `gn-web-plataforma/source/package.json`. Quando
 * gn-schemas v1.6+ for publicada e adicionada como dep, substituir
 * este arquivo por:
 *
 *   export * from '@greennexus/schemas';
 *
 * e remover o diretorio `src/types/events/`.
 *
 * Eventos SSE publicados por `gn-api-consolidate-service` em
 * `/events/status/{file_id}` e `/events/state/{file_id}`.
 * Backend canonico: gn-api-consolidate-service/src/api/sse_status.py
 */

export const PROPERTY_PROCESSING_STATUSES = [
  'process_started',
  'process_succeeded',
  'process_failed',
  'cache_hit',
  'domain_started',
  'domain_succeeded',
  'domain_failed',
  'domain_skipped',
] as const;

export type PropertyProcessingStatus = (typeof PROPERTY_PROCESSING_STATUSES)[number];

export const TERMINAL_PROPERTY_PROCESSING_STATUSES: ReadonlySet<PropertyProcessingStatus> =
  new Set<PropertyProcessingStatus>(['process_succeeded', 'process_failed', 'cache_hit']);

export function isTerminalPropertyProcessingStatus(
  status: string | undefined | null,
): status is PropertyProcessingStatus {
  return (
    typeof status === 'string' &&
    TERMINAL_PROPERTY_PROCESSING_STATUSES.has(status as PropertyProcessingStatus)
  );
}

export interface PropertyStatusEvent {
  filename: string;
  status: PropertyProcessingStatus | string;
  domain?: string;
  request_id?: string;
  trace_id?: string;
  client_id?: string;
}

export interface PropertyStateUpdateEvent {
  file_id?: string;
  status?: PropertyProcessingStatus | string;
  status_timeline?: string[];
  [key: string]: unknown;
}
